export const hydrateObjects = (data, graphObject) => {

    graphObject ??= {};

    if (data && Object.hasOwn(data, "$id")) {
        graphObject[data.$id] = data;
    }

    if (data && Object.hasOwn(data, "$ref")) {
        return graphObject[data.$ref]
    }

    for (const prop in data) {
        if (typeof data[prop] === 'object' && data[prop]) {
            data[prop] = hydrateObjects(data[prop], graphObject);
        }
    }

    return data;

};

const remove_$ids = data => {

    if (data && Object.hasOwn(data, "$id")) {
        delete data.$id;
    }

    for (const prop in data) {
        if (typeof data[prop] === 'object' && data[prop]) {
            remove_$ids(data[prop]);
        }
    }

    return data;

};

export const cleanUpJsonForTransport = data => {

    if (data.hasOwnProperty('$values') && Array.isArray(data.$values)) {
        // Set data to $values
        data = [].concat(data.$values);
    }

    // Recursively inspect nested objects
    for (const prop in data) {
        if (data[prop] !== null && typeof data[prop] === 'object') {
            data[prop] = cleanUpJsonForTransport(data[prop]);
        }
    }

    return remove_$ids(data);
};